import React from 'react';
import './Header.css';

/**
 * Header component with logo and title display
 * @param {Object} props - Component props
 * @param {string} props.logoSrc - Path to the logo image
 * @param {string} props.titleLogoSrc - Path to the title logo image
 * @param {string} props.headerClass - CSS class for the header (App-header or App-header2)
 * @param {Object} props.logoStyle - Custom style for the logo
 * @param {Object} props.titleLogoStyle - Custom style for the title logo
 * @param {ReactNode} props.children - Child components to render inside the header
 */
const Header = ({ 
  logoSrc, 
  titleLogoSrc, 
  headerClass = 'App-header', 
  logoStyle = {},
  titleLogoStyle = {},
  children 
}) => {
  // Default styles that will be merged with custom styles
  const defaultLogoStyle = {
    width: '15%', 
    height: '15%'
  };
  
  const defaultTitleLogoStyle = { 
    width: '20%', 
    height: '20%', 
    position: 'relative', 
    top: '10px' 
  };

  return (
    <header className={headerClass}>
      <div className="header-content">
        {logoSrc && (
          <img 
            src={logoSrc} 
            style={{...defaultLogoStyle, ...logoStyle}}
            className="App-logo" 
            alt="Moving logo" 
          />
        )}
        
        {titleLogoSrc && (
          <img 
            src={titleLogoSrc} 
            style={{...defaultTitleLogoStyle, ...titleLogoStyle}}
            alt="Title logo" 
          />
        )}
        
        {children}
      </div>
    </header>
  );
};

export default Header;
